import { Const } from '../lib/const.cls'

export const mutations = {
	//withdrawal list
	[Const.SET_SKRILL_ID](state, data) {
		try { state.skrill_id_data = data } catch (ex) { console.debug('set state EX', ex) }
	},
	[Const.SET_NETELLER_ID](state, data) {
		try { state.neteller_id_data = data } catch (ex) { console.debug('set state EX', ex) }
	},

	[Const.SET_CRYPTO_ID_LIST](state, data) {
		try { state.crypto_id_list = data } catch (ex) { console.debug('set state EX', ex) }
	},
	//dashboard
	[Const.SET_DASHBOARD_CHART_DATA](state, data) {
		try { state.ChartData = data } catch (ex) { console.debug('set state EX', ex) }
	},
	//support
	[Const.SET_TICKET_LIST](state, data) {
		try { state.ticketList = data } catch (ex) { console.debug('set state EX', ex) }
	},
	[Const.SET_TICKET_VIEW](state, data) {
		try { state.ticketView = data } catch (ex) { console.debug('set state EX', ex) }
	},
	[Const.SET_TICKET_REASON_LIST](state, data) {
		try { state.ticketReasonList = data } catch (ex) { console.debug('set state EX', ex) }
	},
	[Const.SET_TICKET_DATA](state, data) {
		try { state.ticketData = data } catch (ex) { console.debug('set state EX', ex) }
	},


	[Const.SET_USER_PROFILE](state, data) {
		try { state.userProfile = data } catch (ex) { console.debug('set state EX', ex) }
	},
	[Const.SET_COUNTRIES_LIST](state, data) {
		try { state.countriesList = data } catch (ex) { console.debug('set state EX', ex) }
	},
	[Const.SET_CITIES_LIST](state, data) {
		try { state.citiesList = data } catch (ex) { console.debug('set state EX', ex) }
	},
	[Const.SET_DASHBOARD_DATA](state, data) {
		try { state.dashboardData = data } catch (ex) { console.debug('set state EX', ex) }
	},

	//ib
	[Const.SET_IB_LIST](state, data) {
		try {
			state.ibList = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	[Const.SET_IB_DETAIL](state, data) {
		try {
			state.ibDetail = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	//client
	[Const.SET_WITHDRAWAL_METHODS](state, data) {
		try {
			state.withdrawalMethods = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},


	[Const.SET_USER_LIST](state, data) {
		try {
			state.userList = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	[Const.SET_USER_VIEW](state, data) {
		try {
			state.userView = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	[Const.SET_USER_COUNT](state, data) {
		try {
			state.userCount = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},

	//deposit   
	[Const.SET_DEPOSIT_LIST]: (state, data) => {
		try {
			state.depositList = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	[Const.SET_TRADING_ACCOUNT_DETAIL]: (state, data) => {
		try {
			state.tradAccountDetail = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	[Const.SET_DEPOSIT_VIEW]: (state, data) => {
		try {
			state.depositView = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},

	//bonus
	[Const.SET_BONUS_LIST]: (state, data) => {
		try {
			state.bonusList = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	[Const.SET_BONUS_VIEW]: (state, data) => {
		try {
			state.bonusView = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},


	//withdrawal
	[Const.SET_SKRILL_ID]: (state, data) => {
		try {
			state.skrill_id_data = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	[Const.SET_WITHDRAWAL_LIST]: (state, data) => {
		try {
			state.withdrawalList = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	[Const.SET_WITHDRAWAL_COMMISSION_LIST]: (state, data) => {
		try {
			state.withdrawalCommList = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	[Const.SET_AFFILIATE_EARNINGS]: (state, data) => {
		try {
			state.affiliateCommList = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	[Const.SET_WITHDRAWAL_VIEW]: (state, data) => {
		try {
			state.withdrawalView = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	[Const.SET_WITHDRAWAL_METHOD_RESPONSE](state, data) {
		try { state.withdrawalMethodResponse = data } catch (ex) { console.debug('set state EX', ex) }
	},

	[Const.SET_WITHDRAWAL_METHOD_RESPONSE_DEP](state, data) {
		try { state.withdrawalMethodResponseDep = data } catch (ex) { console.debug('set state EX', ex) }
	},

	//trading
	[Const.SET_TRADING_LIST]: (state, data) => {
		try {
			state.tradingList = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	[Const.SET_IB_TRADING_LIST]: (state, data) => {
		try {
			state.ibtradingList = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	[Const.SET_TRADING_VIEW]: (state, data) => {
		try {
			state.tradingView = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},

	// user sub ib list
	[Const.SET_USER_SUBIB_LIST]: (state, data) => {
		try {
			state.subIbList = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},

	[Const.SET_TRADING_ACCOUNT_LIST]: (state, data) => {
		try {
			state.tradingAccountList = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},

	[Const.SET_USER_COMMISSION]: (state, data) => {
		try {
			state.userCommission = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
}



// WEBPACK FOOTER //
// ./src/plugins/fxView/provider/candle-history/store-addons/mutations.js